import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQueryClient, useMutation } from 'react-query';

function useCreateOrUpdateEpisode() {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;
  const queryClient = useQueryClient();

  function createEpisode({ podcastId, ...rest }) {
    return privateFetch.post(`/v1/admin/podcast/${podcastId}/episode`, rest);
  }

  function updateEpisode({ podcastId, episodeId, ...rest }) {
    return privateFetch.put(`/v1/admin/podcast/${podcastId}/episode/${episodeId}`, rest);
  }

  function handleEpisode(data) {
    if (data.episodeId) return updateEpisode(data);
    return createEpisode(data);
  }

  return useMutation(handleEpisode, {
    onSuccess(responseData) {},
    onError(error) {},
    onSettled() {
      queryClient.invalidateQueries('podcast-episode');
    },
  });
}

export default useCreateOrUpdateEpisode;
